<!-- HTML -->
<template>
  <div class="relative ml2 mt1" style="width: 100%">
    <!-- Edit title -->
    <div
      @click="editTitle()"
      v-show="!edit_title_mode"
      class="flex middle-xs edit-container"
    >
      <div
        class="pl-headline middle-xs truncate-text"
        style="font-weight: bold; white-space: nowrap; font-size: 24px"
      >
        {{ getCurrentDiscussion.title }}
        <!-- <div v-if="needToChangeTitle" class="top-2 nowrap tl absolute pl-caption italics pulsate">
          click to edit your discussion title
        </div> -->
      </div>
      <div
        v-if="hasTeacherPermissionsInCourse || needToChangeTitle"
        class="row middle-xs no-margin pencil-container"
        :class="{ 'show-pencil': needToChangeTitle }"
      >
        <i
          class="fas fa-pencil-alt"
          style="margin: 0px 10px; font-size: 12px; opacity: 0.6"
        />
      </div>
    </div>
    <div class="pl-body-1" :id="'onboarding-edit-roundtable-title'"></div>
    <div
      ref="edit-title-container"
      v-show="edit_title_mode"
      style="min-width: 80%"
    >
      <input
        ref="edit-title"
        class="edit-rt-title-input"
        @focus="edit_title_mode = true"
        @blur="saveTitle()"
        @keyup.enter.prevent="saveTitle()"
        v-model="roundtable_title"
      />
    </div>

    <!-- NOTE: Current idea was disabled in August 2019 as per request.  -->
    <!-- I commented out this code just in case things change. -->
    <!-- If you're seeing this some time in 2020, you can probably remove this code entirely -->
    <!-- Edit Current Idea -->
    <!-- <div
      @click="editCurrentIdea()"
      v-show="!edit_current_idea_mode"
      class="flex middle-xs edit-container"
    >
      <div class="middle-xs relative tl" v-if="hasTeacherPermissionsInCourse || getCurrentDiscussion.current_idea">
        {{ getCurrentDiscussion.current_idea || 'Current Topic / Question' }}
      </div>
      <div
        v-if="hasTeacherPermissionsInCourse || needToChangeCurrentIdea"
        class="row middle-xs no-margin pencil-container"
        :class="{ 'show-pencil' : needToChangeCurrentIdea }">
        <i class="fas fa-pencil-alt" style="margin: 0px 10px; font-size: 12px; opacity: 0.6" />
      </div>
    </div>
    <div class="pl-body-1" :id="'onboarding-edit-roundtable-title'"></div>
    <div
      ref="edit-current-idea-container"
      v-show="edit_current_idea_mode"
      style="min-width: 80%">
      <input
        style="width: 100%"
        ref="edit-current-idea"
        class="edit-rt-title-input"
        @focus="edit_current_idea_mode = true"
        @blur="saveCurrentIdea()"
        @keyup.enter.prevent="saveCurrentIdea()"
        v-model="roundtable_current_idea" />
    </div> -->
  </div>
</template>

<!-- JS -->
<script lang="babel">
  import { mapGetters } from 'vuex';
  import store from 'store';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        edit_current_idea_mode: false,
        edit_title_mode: false,
        roundtable_title: '',
        roundtable_current_idea: '',
      };
    },
    computed: {
      ...mapGetters([
        'getCurrentDiscussion',
        'hasTeacherPermissionsInCourse',
      ]),
      needToChangeTitle() {
        if (this.hasTeacherPermissionsInCourse) {
          return this.getCurrentDiscussion.title.toLowerCase() === 'verbal discussion';
        }
        return false;
      },
      needToChangeCurrentIdea() {
        if (this.hasTeacherPermissionsInCourse) {
          return !this.getCurrentDiscussion.current_idea
            || this.getCurrentDiscussion.current_idea.toLowerCase() === 'Current Idea';
        }
        return false;
      },
    },
    methods: {
      saveTitle() {
        const length = this.roundtable_title.length || 0;
        if (length < 4 || length > 55) {
          const msg = 'Title must be between 4 and 55 characters';
          EventBus.$emit('toast-msg', msg);
          return;
        }
        setTimeout(() => {
          if (this.getCurrentDiscussion.title !== this.roundtable_title) {
            this.saveRoundtable({ title: this.roundtable_title });
          }
            this.edit_title_mode = false;
        }, 200);
      },
      saveCurrentIdea() {
        const length = this.roundtable_current_idea.length || 0;
        if (length < 4 || length > 99) {
          const msg = 'Current topic/question must be between 4 and 99 characters';
          EventBus.$emit('toast-msg', msg);
          return;
        }
        setTimeout(() => {
          if (this.getCurrentDiscussion.current_idea !== this.roundtable_current_idea) {
            this.saveRoundtable({ current_idea: this.roundtable_current_idea });
          }
            this.edit_current_idea_mode = false;
        }, 200);
      },
      saveRoundtable(payload) {
        payload.id = this.getCurrentDiscussion.id;
        store.dispatch('saveLiveDiscussionSettings', payload);
        store.dispatch('editActivityInCourseState', payload);
      },
      editTitle() {
        if (!this.hasTeacherPermissionsInCourse) { return; }
        this.edit_title_mode = true;
        this.roundtable_title = this.getCurrentDiscussion.title;
        const element = this.$refs['edit-title'];
        // for some reason setTimeout is needed
        setTimeout(() => {
          element.focus();
        }, 100);
      },
      editCurrentIdea() {
        if (!this.hasTeacherPermissionsInCourse) { return; }
        this.edit_current_idea_mode = true;
        this.roundtable_current_idea = this.getCurrentDiscussion.current_idea;
        const element = this.$refs['edit-current-idea'];
        // for some reason setTimeout is needed
        setTimeout(() => {
          element.focus();
        }, 100);
      },
    },
  };
</script>
<!-- CSS -->
<style scoped lang="stylus">

  // *
  //   outline: 1px solid red

  @import '~app/global-stylus.styl'

  .edit-rt-title-input
    position: relative
    width: 100%
    padding: 6px
    outline: none
    border: 2px solid #e1e8ee
    border-radius: 5px
    font-size: 16px
    &:focus
      border-color: pl-primary

  .pencil-container
    visibility: hidden
  .show-pencil.pencil-container
    visibility: visible

  .edit-container
    &:hover
      .pencil-container
        visibility: visible
</style>



// WEBPACK FOOTER //
// editTitleInline.liveDiscussion.vue?1e2aa71b